import Axios from 'axios';

const competitionGolfApi = process.env.REACT_APP_COMPETITIONGOLF_PUBLIC_API_ENDPOINT;

class UserService {

    getUserSocialProfile (userId) {
      return Axios.get(competitionGolfApi + 'user/' + userId + '/socialprofile')
        .then(resp => resp.data)
        .catch(err => {
          window.rg4js('send', {
            error: err
          });
        });
    }

    setUserSocialProfile (socialProfile) {
      return Axios.put(competitionGolfApi + 'user/' + socialProfile.userId + '/socialprofile', socialProfile)
        .then(resp => resp.data)
        .catch(err => {
          window.rg4js('send', {
            error: err
          });
          throw err;
        });
    }

    getUserDetails (userId) {
      return Axios.get(competitionGolfApi + 'user/' + userId)
        .then(resp => resp.data)
        .catch(err => {
          window.rg4js('send', {
            error: err
          });
        });
    }

    setUserDetails (userDetails) {
      return Axios.put(competitionGolfApi + 'user/' + userDetails.userId, userDetails)
        .then(resp => resp.data)
        .catch(err => {
          window.rg4js('send', {
            error: err
          });
          throw err;
        });
    }

    setUserAvatar (userId, newAvatar) {
      return Axios.put(competitionGolfApi + 'user/' + userId + '/image', {"image" : newAvatar.data, "format" :"jpeg"})
        .then(resp => resp.data)
        .catch(err => {
          window.rg4js('send', {
            error: err
          });
          throw err;
        });
    }

    setUserPassword (userId, newPassword) {
      return Axios.post(competitionGolfApi + 'user/' + userId + '/changepassword', JSON.stringify(newPassword), {headers: {"Content-Type": "application/json"}})
        .then(resp => resp.data)
        .catch(err => {
          window.rg4js('send', {
            error: err
          });
          throw err;
        });
    }

  getUserHandicap (userId) {
    return Axios.get(competitionGolfApi + 'user/' + userId + '/handicap')
      .then(resp => resp.data)
      .catch(err => {
        window.rg4js('send', {
          error: err
        });
      });
  }

  setUserHandicap (handicap) {
    return Axios.put(competitionGolfApi + 'user/' + handicap.userId + '/handicap', handicap)
      .then(resp => resp.data)
      .catch(err => {
        window.rg4js('send', {
          error: err
        });
        throw err;
      });
  }
}

export default UserService;
